import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Acceso inmediato por email con link de descarga. En menos de 5 minutos tenés los 6 tomos y los 6 bonos en tu dispositivo.'
}, {
  q: '¿Sirve si todavía no empecé a rotar por guardia?',
  a: 'Sí. De hecho es el momento ideal para empezar. Estudiá los tomos antes de tu primera rotación y entrás con una ventaja enorme sobre tus compañeros.'
}, {
  q: '¿Está en español argentino?',
  a: 'Sí completamente. Terminología local, contexto argentino, guías nacionales y los fármacos disponibles en Argentina.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos tanto en Guardia Clínica como en Guardia Clínica PLUS sin costo adicional.'
}, {
  q: '¿Sirve para el examen de ingreso a residencia?',
  a: 'Sí. El razonamiento clínico visual que entrenás con este atlas es exactamente lo que evalúan los exámenes de residencia en Argentina.'
}, {
  q: '¿Qué diferencia tiene con los libros de texto tradicionales?',
  a: 'Los libros son densos, teóricos y en inglés. Este atlas es visual, práctico, en español y diseñado para aplicar en guardia, no para leer en el escritorio.'
}, {
  q: '¿Para qué nivel de la carrera está pensado?',
  a: 'Principalmente para 5to año, 6to año e internado. También es muy útil para 4to año que empieza rotaciones clínicas.'
}, {
  q: '¿Por qué elegir el PLUS y no el base?',
  a: 'Si querés la colección completa sin excepción. El Tomo 7 de urgencias respiratorias y el Tomo 8 de toxicología son los que más casos inesperados generan en guardia en Argentina.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días sin preguntas. Si no te sirve te devolvemos el 100% del dinero.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleOpen = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-gray-50" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <div className="text-center mb-10" data-id="element-102">
          <div className="inline-block bg-gray-200 text-gray-700 font-bold px-4 py-1 rounded-full text-xs mb-3 tracking-wider uppercase" data-id="element-103">
            Dudas Comunes
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900" data-id="element-104">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-3" data-id="element-105">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-white rounded-xl border ${isOpen ? 'border-medical-blue shadow-md' : 'border-gray-200 shadow-sm'} overflow-hidden transition-colors`} data-id="element-106">
                <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleOpen(i)} data-id="element-107">
                  <span className={`font-bold text-sm md:text-base pr-4 ${isOpen ? 'text-medical-blue' : 'text-gray-900'}`} data-id="element-108">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="shrink-0" data-id="element-109">
                    <ChevronDown size={20} className={isOpen ? 'text-medical-blue' : 'text-gray-400'} data-id="element-110" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-111">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-112">
                      <div className="px-5 pb-4 pt-1 text-gray-600 text-sm md:text-base border-t border-gray-100" data-id="element-113">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}